import routes from "./routes";
import LogService from "./Service";

export {
  routes,
  LogService
};
